export class Customer {
    id: number;
    name: string;
    count: number;
}
